import { ProCard, ProList } from '@ant-design/pro-components'
import { db } from '@app/icare/client/db'
import { localResultQueryOptions } from '@app/icare/client/db/client/localQueryOptions'
import { type ContactPerson, SalutationEnum } from '@app/icare/db/schema/common'
import type { CostCarrierIdType } from '@app/icare/entities/costCarrier/schema/CostCarrier'
import { ContactColumn } from '@app/icare/routes/_app/apotheken/-components/ContactColumn'
import { ContactPersonEditDrawer } from '@app/icare/routes/_app/apotheken/-components/ContactPersonEditDrawer'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { formatAddress } from '@pkg/shared/utils'
import { CreateButton, EditSectionButton } from '@pkg/ui/button'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Typography } from 'antd'

export const Route = createFileRoute('/_app/kostentrager/$id/contact-persons')({
  component: RouteComponent,
})

function RouteComponent() {
  const ownerId = Route.useParams().id as CostCarrierIdType

  const { data: contactPersons = [], isLoading } = useQuery(
    localResultQueryOptions({
      query: db.selectFrom('contactPerson').selectAll().where('ownerId', '=', ownerId),
    }),
  )

  return (
    <ProCard headerBordered title={t`Ansprechpartner`} className="mx-4" loading={isLoading}>
      <ProList<ContactPerson>
        dataSource={contactPersons}
        rowKey="id"
        size="small"
        split
        ghost
        columns={[
          {
            listSlot: 'title',
            render: (_, { salutation, title, firstName, lastName }) => (
              <Typography.Text className="font-bold">
                {formatAddress([SalutationEnum.$.getLabel(salutation), title, firstName, lastName], undefined)}
              </Typography.Text>
            ),
          },
          {
            listSlot: 'content',
            render: (_, contactPerson) => <ContactColumn input={contactPerson} />,
          },
          {
            listSlot: 'actions',
            render: (_, contactPerson) => (
              <EditSectionButton
                onClick={() => void ContactPersonEditDrawer.show({ ownerId, id: contactPerson.id })}
              >{t`Bearbeiten`}</EditSectionButton>
            ),
          },
        ]}
      />
      <CreateButton onClick={() => void ContactPersonEditDrawer.show({ ownerId })}>
        <Trans>Ansprechpartner hinzufügen</Trans>
      </CreateButton>
    </ProCard>
  )
}
